<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'site.attachments' | translate }}
  </div>
  <div>
    <app-attachments [attachments]="attachments()"
      [isReadOnly]="isReadOnly()"
      (save)="save($event)"></app-attachments>
  </div>
</app-main-dialog>